import React, { useState } from "react";
import Icon from "./icon";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import Vimeo from '@u-wave/react-vimeo';
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/video.module.css";

export const Video = ({ node }) => {

  const [playVideo, setPlayVideo] = useState(false);

  function handlePlayerPlay() {
    setPlayVideo(true);
  }

  function handlePlayerPause() {
    setPlayVideo(false);
  }

  if (!node || !node.url) {
    return null;
  }

  return (
    <div className={cn(styles.root, "pt-media")}>
      <div className={styles.videoWrap}>
        {node.cover && node.cover.asset && (
          <div className={styles.cover}>
            <img
              src={imageUrlFor(buildImageObj(node.cover))
                .auto("format")
                .url()}
              alt={node.cover.alt}
            />
          </div>
        )}
        <div className={styles.action} onClick={handlePlayerPlay} onKeyDown={handlePlayerPlay} role="button" tabIndex={0}>
          <Icon symbol="play" />
        </div>
        <div className={cn(styles.player, playVideo && styles.active)}>
          <Vimeo
            video={node.url}
            paused={!playVideo}
            transparent={false}
            //onPause={handlePlayerPause}
            //onPlay={handlePlayerPlay}
          />
        </div>
      </div>
      {node.cover && node.cover.caption && <div className={styles.caption}>{node.cover.caption}</div>}
    </div>
  );
};

export default Video;
